// Stripe passes all currencies as integers in cents or the smallest unit of the
// currency. This function formats the amount according to the currency's
// decimal places.

// https://docs.stripe.com/currencies#zero-decimal
const ZERO_DECIMAL = new Set([
  "BIF",
  "CLP",
  "DJF",
  "GNF",
  "JPY",
  "KMF",
  "KRW",
  "MGA",
  "PYG",
  "RWF",
  "UGX",
  "VND",
  "VUV",
  "XAF",
  "XOF",
  "XPF",
]);

export function formatStripeCurrency(amount: number, currency: string, locale = "en-US") {
  const currencyCode = currency.toUpperCase();
  const convertedAmount = ZERO_DECIMAL.has(currencyCode) ? amount : amount / 100;

  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: currencyCode,
  }).format(convertedAmount);
}
